import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const Toast = ({ toast }) => {
  // Helper to pick the right icon
  const getIcon = () => {
    switch (toast.type) {
      case 'success': return <CheckCircle2 size={20} />;
      case 'warning': return <AlertTriangle size={20} />;
      case 'error': return <AlertCircle size={20} />;
      default: return <Info size={20} />;
    }
  };

  return (
    <AnimatePresence>
      {toast.show && (
        <motion.div 
          initial={{ opacity: 0, y: -100, x: '-50%' }}
          animate={{ opacity: 1, y: 20, x: '-50%' }}
          exit={{ opacity: 0, y: -100, x: '-50%' }}
          // Ensure classes match the CSS above
          className={`toast-notification ${toast.type}`}
        >
          {getIcon()}
          <span>{toast.message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;